import React, { Component } from "react";
import Chevron from "./Chevron";
import { translate } from '../Services/translation';

class VariantChooser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showVariants: false,
        };

        this.handleMenu = this.handleMenu.bind(this);
    }

    // Block end
    handleMenu() {
        const currentVariantShow = this.state.showVariants;
        this.setState({ showVariants: !currentVariantShow });
    }

    render() {
        return (
            (!this.props.variants || (this.props.variants.length <= 1)) ? (<div> </div>) : (
                <div>
                  <span className="variant__title">{this.props.variants.length > 0 ? translate('variantselectortitle')  : ""} </span>
                    <button className="variantChooser-button" onClick={this.handleMenu}>
                    <img
                    className="variantchooser-image"
                    src={this.props.variants.filter(x => x.selected)[0].image}
                    alt={this.props.variants.filter(x => x.selected)[0].imageAlt} />
              <div className="variantChooser-content">
                <span className="variantChooser-content-title">
                    {this.props.variants.filter(x => x.selected)[0].title}
                </span>
            </div>
          <Chevron
                            className={
                                "variantChooser-chevron " +
                                (this.state.showVariants ? "active" : "")
                            }
                        />
                    </button>
                    <div
                        className="variantChooser"
                        aria-expanded={this.state.showVariants ? "true" : "false"}
                    >
                        <ul
                            className={
                                "variantChooser-list " +
                                (this.state.showVariants ? "active" : null)
                            }
                        >
                            {this.props.variants.filter(x => !x.selected).map(item => (
                                <li key={item.id}>
                                    <a href={item.url}>
                                        <img
                                            className="variantchooser-image"
                                            src={item.image}
                                            alt={item.imageAlt}
                                            role="presentation"
                                        />
                                        <div className="variantChooser-content">
                                            <span className="variantChooser-content-title">
                                                {item.title}
                                            </span>
                                            <span className="variantChooser-content-price">
                                                {item.price}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>)
        );
    }
}

export default VariantChooser;
